import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const getInitialSession = async () => {
      try {
        // Try to get auth info from URL parameters
        const params = new URLSearchParams(window.location.search);
        let token = params.get('token');
        let userId = params.get('user_id');
        let email = params.get('email');
        let name = params.get('name');
        let role = params.get('role');

        // If not in search params, try hash format
        if (!token || !userId || !email) {
          const hash = window.location.hash.substring(1); // Remove the # symbol
          const hashParams = new URLSearchParams(hash);
          token = hashParams.get('token');
          userId = hashParams.get('user_id');
          email = hashParams.get('email');
          name = hashParams.get('name');
          role = hashParams.get('role');
        }

        if (token && userId && email) {
          const user = {
            id: userId,
            email: decodeURIComponent(email),
            name: name ? decodeURIComponent(name) : null,
            role: role ? decodeURIComponent(role) : null,
            token
          };

          if (mounted) {
            setUser(user);
            // Clean up URL
            window.history.replaceState({}, document.title, window.location.pathname);
          }
        }
      } catch (error) {
        console.error('Error getting initial session:', error);
        setUser(null);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    getInitialSession();

    return () => {
      mounted = false;
    };
  }, []);

  return { user, loading };
}